import { render, staticRenderFns } from "./AllAppointmentsNotesDialog.vue?vue&type=template&id=5260ec38&"
import script from "./AllAppointmentsNotesDialog.vue?vue&type=script&lang=js&"
export * from "./AllAppointmentsNotesDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports